import { Box } from '@mui/material';
import React, { FC } from 'react';
import { BhiDialog } from 'src/UIKit';
import { FormView } from 'src/components/FormPart/FormView';
import { ApplyForVettingForm } from './ApplyForVettingForm';
import { ApplyForVettingDialogViewModel } from '../../../controllers/ApplyForVettingDialogController';

type ApplyForVettingDialogViewProps = ApplyForVettingDialogViewModel;

const ApplyForVettingDialogView: FC<ApplyForVettingDialogViewProps> = ({
  open,
  formData,
  submitting,
  optionsLoading,
  vettingOptions,
  close,
  submit,
}) => {
  return (
    <BhiDialog
      isOpen={open}
      onClose={close}
      title="Apply for New Vetting"
      maxWidth="sm"
    >
      <Box p={2.5} pt={0}>
        <FormView
          formData={formData}
          component={ApplyForVettingForm}
          componentProps={{ submitting, optionsLoading, vettingOptions }}
          onSubmit={submit}
        />
      </Box>
    </BhiDialog>
  );
};

export default ApplyForVettingDialogView;
